<div class="bg-white">
  <app-carousel [items]="banners$ | async">
    <img class="w-full" trackingLoad src="assets/images/fachada.webp" alt="preview" />
    <ng-template let-slide>
      <a
        *ngIf="!!slide?.url; else semLink"
        class="hover:brightness-105"
        [href]="slide.url"
        [target]="slide.url === '#contacto' ? '_self' : '_blank'"
        (click)="handleBannerClick(slide.url, $event)"
      >
        <img class="w-full" [src]="slide.image" trackingLoad [alt]="'global.facade' | translate" />
      </a>
      <ng-template #semLink>
        <img class="w-full" [src]="slide.image" trackingLoad [alt]="'global.facade' | translate" />
      </ng-template>
    </ng-template>
  </app-carousel>
</div>

<!-- Statistic in numbers -->
<app-card-statistic></app-card-statistic>

<!-- School detail -->
<app-card-school-detail></app-card-school-detail>

<!-- Educational levels -->
<app-card-educational-level></app-card-educational-level>

<!-- Structure -->
<app-card-structure></app-card-structure>

<!-- Stay tuned -->
<app-card-stay-tuned></app-card-stay-tuned>

<!-- Student focus -->
<app-card-student></app-card-student>

<!-- Video -->
<div class="youtube">
  <div class="youtube__section">
    <div class="youtube__container">
      <iframe
        class="youtube__video"
        loading="lazy"
        [src]="institucional$ | async | safe: 'resourceUrl'"
        title="YouTube video player"
        data-autoplay="1"
        frameborder="0"
        allowfullscreen=""
      ></iframe>
    </div>
  </div>
</div>

<!-- Network projects -->
<app-card-network-projects></app-card-network-projects>

<!-- Location Map -->
<app-card-location id="location"></app-card-location>
